import type { ReactNode } from "react";
import "./ScheduleValidationSnackbar.scss";
import { useTranslation } from "react-i18next";
import { Snackbar } from "@mui/material";

interface Properties {
  open: boolean;
  onClose: () => void;
  validatedCount: number;
}

export default function ScheduleValidationSnackbar(
  props: Properties,
): ReactNode {
  const { t } = useTranslation(["humanResources"], {
    keyPrefix: "timeManagement",
  });
  return (
    <Snackbar
      open={props.open}
      autoHideDuration={2000}
      onClose={props.onClose}
      anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
    >
      <div className="schedule-validation-snackbar">
        <div>
          {t("scheduleAlerts.validateScheduleSuccess", {
            count: props.validatedCount,
          })}
        </div>
        <div className="close-button" onClick={props.onClose} />
      </div>
    </Snackbar>
  );
}
